import BaseService from './base';

export interface LiteratureAdviceViewModel {
  id?: any;
  literatureID?: string;
  userID?: string;
  content?: string;
}


export class LiteratureAdviceService extends BaseService<LiteratureAdviceViewModel> {
  protected serviceApi: string = 'LiteratureAdvice';

  get NewModel(): LiteratureAdviceViewModel {
    return {
      content: '',
    };
  }
}
